import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowLeft as leftArrow} from "@fortawesome/pro-regular-svg-icons";

import {  useHistory } from 'react-router-dom';


const useStyles = makeStyles(theme => ({   
    header: {
        fontFamily:'Mulish', 
        fontWeight: '200',
        width:'100%',
        height:'3em',        
        backgroundColor: '#202146',
        color: 'white',

        display:'flex',
        justifyContent:'flex-start',
        alignItems:'center',
        flexShrink:0,
        fontWeight: 'bold',
        
    }, 
    arrow:  {
        fontSize: '2em',
        
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'center',
        justifySelf: 'flex-start',

        width: '40px',
        paddingLeft: '.5em',
        
    },
    title: {
        display: 'flex', 
        flexDirection: 'row', 
        width:'100%',
        justifyContent: 'center', 
        marginRight: '3em',
    }

    }));




const AppHeader = (props) => {
    const classes = useStyles();

    const history = useHistory();

    return(              
        <div className={classes.header}>         
             <div className={classes.arrow} >
               {props.backButton==true && <FontAwesomeIcon icon={leftArrow} onClick={_=>history.goBack()} /> }
            </div>   
            
            <div className={classes.title}>
                CarDetails
            </div>
        </div>     
    )
};

export default AppHeader;